import React from "react";
import { Helmet } from "react-helmet";

const About = () => {
  return (
    <>
      <Helmet>
        <title>{"About SunKissedDelight"}</title>
        <meta name="title" content={`${"About SunKissedDelight"}`} />
        <meta
          property="og:description"
          content="India’s first Vitamin D chocolate from Eykam Wellness. Healthy. Delicious. Effective."
        />
        <link rel="canonical" href={`https://sunkisseddelight.com/about-us/`} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          href={`https://sunkisseddelight.com/about-us/`}
        />
        <meta property="og:title" content={`${"About SunKissedDelight"}`} />
        <meta
          property="og:description"
          content="India’s first Vitamin D chocolate from Eykam Wellness. Healthy. Delicious. Effective."
        />
      </Helmet>
      <main
        id="qodef-page-content"
        className="qodef-grid qodef-layout--template "
      >
        <div className="qodef-grid-inner clear">
          <div className="qodef-grid-item qodef-page-content-section qodef-col--12">
            <div
              data-elementor-type="wp-page"
              data-elementor-id={4445}
              className="elementor elementor-4445"
              data-elementor-settings="[]"
            >
              <div className="elementor-inner">
                <div className="elementor-section-wrap">
                  <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-d2122a6 elementor-section-full_width elementor-section-height-min-height elementor-section-height-default elementor-section-items-middle qodef-elementor-content-no"
                    data-id="d2122a6"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-row">
                        <div
                          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-cf1bc04"
                          data-id="cf1bc04"
                          data-element_type="column"
                        >
                          <div className="elementor-column-wrap">
                            <div className="elementor-widget-wrap"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <br />
                  <br />
                  <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-e9fd090 elementor-reverse-tablet elementor-reverse-mobile qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="e9fd090"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-row">
                        <div
                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b2a6e50"
                          data-id="b2a6e50"
                          data-element_type="column"
                        >
                          <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap">
                              <div
                                className="elementor-element elementor-element-10860d3 elementor-widget elementor-widget-swissdelight_core_section_title"
                                data-id="10860d3"
                                data-element_type="widget"
                                data-widget_type="swissdelight_core_section_title.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left  qodef-appear-animation--enabled">
                                    <h2
                                      className="qodef-m-title"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#38190E",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      our{" "}
                                      <span className="qodef-subtitle-wrapper">
                                        story
                                        <span
                                          className="qodef-m-subtitle"
                                          style={{ color: "#DFBB8166" }}
                                        >
                                          sweet
                                        </span>
                                      </span>{" "}
                                    </h2>
                                    <p
                                      className="qodef-m-text"
                                      style={{ marginTop: 15 }}
                                    >
                                      At Eykam Wellness, we believe that good
                                      health should feel good too.
                                    </p>

                                    <p
                                      className="qodef-m-text"
                                      style={{ marginTop: 15 }}
                                    >
                                      That’s why we created Sun Kissed Delight
                                      India’s first Vitamin D chocolate that
                                      combines science with indulgence. Born out
                                      of a simple observation Vitamin D
                                      deficiency is widespread, but compliance
                                      is low, we wanted to create something
                                      people actually enjoy taking.
                                    </p>

                                    <p
                                      className="qodef-m-text"
                                      style={{ marginTop: 15 }}
                                    >
                                      Most people forget tablets. Kids hate the
                                      taste of drops. Sachets are a hassle.
                                    </p>
                                    <p
                                      className="qodef-m-text"
                                      style={{ marginTop: 15 }}
                                    >
                                      <b>So we asked:</b> what if your weekly or
                                      monthly dose could feel like a treat, not
                                      a task?
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-0aecc00"
                          data-id="0aecc00"
                          data-element_type="column"
                        >
                          <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap">
                              <div
                                className="elementor-element elementor-element-39f7f9b elementor-widget elementor-widget-image"
                                data-id="39f7f9b"
                                data-element_type="widget"
                                data-widget_type="image.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-image">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={1024}
                                      height={934}
                                      src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388768/IMG_0080_enmfhk.webp"
                                      className="attachment-large size-large"
                                      alt="k"
                                      srcSet="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388768/IMG_0080_enmfhk.webp"
                                      sizes="auto, (max-width: 1024px) 100vw, 1024px"
                                    />{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <br />
                  <br />
                  <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-d39efb1 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="d39efb1"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                  >
                    <div className="elementor-container elementor-column-gap-default">
                      <div className="elementor-row">
                        <div
                          className="elementor-column elementor-col-40 elementor-top-column elementor-element elementor-element-b47f8d9"
                          data-id="b47f8d9"
                          data-element_type="column"
                        >
                          <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap">
                              <div
                                className="elementor-element elementor-element-c7715d5 elementor-widget elementor-widget-image"
                                data-id="c7715d5"
                                data-element_type="widget"
                                data-widget_type="image.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="elementor-image">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={800}
                                      height={730}
                                      src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388760/Solar_Post_sbi4e2.webp"
                                      className="attachment-large size-large"
                                      alt="s"
                                      srcSet="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388760/Solar_Post_sbi4e2.webp"
                                    />{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-d868597"
                          data-id="d868597"
                          data-element_type="column"
                        >
                          <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap">
                              <div
                                className="elementor-element elementor-element-97cb1e4 elementor-widget elementor-widget-swissdelight_core_section_title"
                                data-id="97cb1e4"
                                data-element_type="widget"
                                data-widget_type="swissdelight_core_section_title.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--left qodef-appear-animation--enabled">
                                    <h2
                                      className="qodef-m-title"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#38190E",
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      What Makes Us Different
                                    </h2>

                                    <ol
                                      className="feature-list"
                                      style={{
                                        marginTop: 15,
                                        marginLeft: "0px",
                                        listStyle: "none",
                                      }}
                                    >
                                      <li
                                        className="list"
                                        style={{ marginTop: 15 }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                          }}
                                        >
                                          <strong className="strong">1 </strong>{" "}
                                          India’s first Vitamin D chocolate
                                        </div>
                                      </li>
                                      <li
                                        className="list"
                                        style={{ marginTop: 15 }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                          }}
                                        >
                                          <strong className="strong">2 </strong>{" "}
                                          Two formats: 3500 IU (weekly) & 15000
                                          IU (monthly)
                                        </div>
                                      </li>
                                      <li
                                        className="list"
                                        style={{ marginTop: 15 }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                          }}
                                        >
                                          <strong className="strong">3 </strong>{" "}
                                          Available in both regular & sugar-free
                                          variants
                                        </div>
                                      </li>
                                      <li
                                        className="list"
                                        style={{ marginTop: 15 }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                          }}
                                        >
                                          <strong className="strong">4 </strong>{" "}
                                          Backed by science, trusted by doctors
                                        </div>
                                      </li>
                                      <li
                                        className="list"
                                        style={{ marginTop: 15 }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                          }}
                                        >
                                          <strong className="strong">5 </strong>{" "}
                                          Suitable for everyone aged 5 and above
                                        </div>
                                      </li>
                                    </ol>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <br />
                  <br />
                  <div
                    className="elementor-section-wrap"
                    style={{
                      background: "#38190E",
                      color: "#fff",
                      padding: "65px 0px 65px 0px",
                    }}
                  >
                    <section
                      className="elementor-section elementor-top-section elementor-element elementor-element-0f9ffc9 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="0f9ffc9"
                      data-element_type="section"
                    >
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-row">
                          <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-81c4b21"
                            data-id="81c4b21"
                            data-element_type="column"
                          >
                            <div
                              className="elementor-column-wrap elementor-element-populated"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <div>
                                <div
                                  className="elementor-element elementor-element-7871ffe elementor-widget__width-initial elementor-widget elementor-widget-swissdelight_core_section_title"
                                  data-id="7871ffe"
                                  data-element_type="widget"
                                  data-widget_type="swissdelight_core_section_title.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m qodef-section-title qodef-alignment--center qodef-appear-animation--enabled">
                                      <h3
                                        style={{
                                          width: "80vw",
                                          maxWidth: "1280px",
                                          color: "#fff",
                                          fontWeight: "800",
                                          textTransform: "capitalize",
                                        }}
                                      >
                                        Why Vitamin D Matters
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <section
                      className="elementor-section elementor-top-section elementor-element elementor-element-fe7d420 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="fe7d420"
                      data-element_type="section"
                    >
                      <div className="elementor-container elementor-column-gap-default">
                        <div
                          className="elementor-row"
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2784e54 w-50"
                            data-id="2784e54"
                            data-element_type="column"
                          >
                            <div className="elementor-column-wrap elementor-element-populated">
                              <div className="elementor-widget-wrap">
                                <div
                                  className="elementor-element elementor-element-64dbb60 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                  data-id="64dbb60"
                                  data-element_type="widget"
                                  data-widget_type="swissdelight_core_image_with_text.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                      <div className="qodef-m-image">
                                        <a
                                          itemProp="url"
                                          href="#/"
                                          target="_self"
                                        >
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            width={138}
                                            height={138}
                                            src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388514/A1_iyxtj2.png"
                                            className="attachment-full size-full"
                                            alt="f"
                                            sizes="auto, (max-width: 138px) 100vw, 138px"
                                          />
                                        </a>
                                      </div>
                                      <div className="qodef-m-content">
                                        <h5 className="qodef-m-title">
                                          <a
                                            itemProp="url"
                                            href="#/"
                                            target="_self"
                                            style={{ color: "#fff" }}
                                          >
                                            Bone strength
                                          </a>
                                        </h5>
                                        <p className="qodef-m-text">
                                          supports calcium absorption
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-318d51d w-50"
                            data-id="318d51d"
                            data-element_type="column"
                          >
                            <div className="elementor-column-wrap elementor-element-populated">
                              <div className="elementor-widget-wrap">
                                <div
                                  className="elementor-element elementor-element-c365459 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                  data-id="c365459"
                                  data-element_type="widget"
                                  data-widget_type="swissdelight_core_image_with_text.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                      <div className="qodef-m-image">
                                        <a
                                          itemProp="url"
                                          href="#/"
                                          target="_self"
                                        >
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            width={138}
                                            height={138}
                                            src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388515/A2_xn29hu.png"
                                            className="attachment-full size-full"
                                            alt="e"
                                            sizes="auto, (max-width: 138px) 100vw, 138px"
                                          />
                                        </a>
                                      </div>
                                      <div className="qodef-m-content">
                                        <h5 className="qodef-m-title">
                                          <a
                                            itemProp="url"
                                            href="#/"
                                            target="_self"
                                            style={{ color: "#fff" }}
                                          >
                                            Immunity
                                          </a>
                                        </h5>
                                        <p className="qodef-m-text">
                                          boosts your natural defense system
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-563ab28"
                            data-id="563ab28"
                            data-element_type="column"
                          >
                            <div className="elementor-column-wrap elementor-element-populated">
                              <div className="elementor-widget-wrap">
                                <div
                                  className="elementor-element elementor-element-ee806d6 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                  data-id="ee806d6"
                                  data-element_type="widget"
                                  data-widget_type="swissdelight_core_image_with_text.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                      <div className="qodef-m-image">
                                        <a
                                          itemProp="url"
                                          href="#/"
                                          target="_self"
                                        >
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            width={138}
                                            height={138}
                                            src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388514/A3_a0gszz.png"
                                            className="attachment-full size-full"
                                            alt="f"
                                            sizes="auto, (max-width: 138px) 100vw, 138px"
                                          />
                                        </a>
                                      </div>
                                      <div className="qodef-m-content">
                                        <h5 className="qodef-m-title">
                                          <a
                                            itemProp="url"
                                            href="#/"
                                            target="_self"
                                            style={{ color: "#fff" }}
                                          >
                                            Mood & energy
                                          </a>
                                        </h5>
                                        <p className="qodef-m-text">
                                          linked to better mental health
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section
                      className="elementor-section elementor-top-section elementor-element elementor-element-fe7d420 qodef-elementor-content-grid elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                      data-id="fe7d420"
                      data-element_type="section"
                    >
                      <div className="elementor-container elementor-column-gap-default">
                        <div
                          className="elementor-row"
                          style={{
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "50px",
                          }}
                        >
                          <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2784e54 w-50"
                            data-id="2784e54"
                            data-element_type="column"
                          >
                            <div className="elementor-column-wrap elementor-element-populated">
                              <div className="elementor-widget-wrap">
                                <div
                                  className="elementor-element elementor-element-64dbb60 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                  data-id="64dbb60"
                                  data-element_type="widget"
                                  data-widget_type="swissdelight_core_image_with_text.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                      <div className="qodef-m-image">
                                        <a
                                          itemProp="url"
                                          href="#/"
                                          target="_self"
                                        >
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            width={138}
                                            height={138}
                                            src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388514/A4_ayhdxh.png"
                                            className="attachment-full size-full"
                                            alt="f"
                                            sizes="auto, (max-width: 138px) 100vw, 138px"
                                          />
                                        </a>
                                      </div>
                                      <div className="qodef-m-content">
                                        <h5 className="qodef-m-title">
                                          <a
                                            itemProp="url"
                                            href="#/"
                                            target="_self"
                                            style={{ color: "#fff" }}
                                          >
                                            Muscle function
                                          </a>
                                        </h5>
                                        <p className="qodef-m-text">
                                          keeps you active and strong
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div
                            className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-318d51d w-50"
                            data-id="318d51d"
                            data-element_type="column"
                          >
                            <div className="elementor-column-wrap elementor-element-populated">
                              <div className="elementor-widget-wrap">
                                <div
                                  className="elementor-element elementor-element-c365459 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-swissdelight_core_image_with_text"
                                  data-id="c365459"
                                  data-element_type="widget"
                                  data-widget_type="swissdelight_core_image_with_text.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m qodef-image-with-text qodef-layout--text-below">
                                      <div className="qodef-m-image">
                                        <a
                                          itemProp="url"
                                          href="#/"
                                          target="_self"
                                        >
                                          <img
                                            loading="lazy"
                                            decoding="async"
                                            width={138}
                                            height={138}
                                            src="https://res.cloudinary.com/dgne9mq7j/image/upload/v1747388519/A5_rirdkr.png"
                                            className="attachment-full size-full"
                                            alt="e"
                                            sizes="auto, (max-width: 138px) 100vw, 138px"
                                          />
                                        </a>
                                      </div>
                                      <div className="qodef-m-content">
                                        <h5 className="qodef-m-title">
                                          <a
                                            itemProp="url"
                                            href="#/"
                                            target="_self"
                                            style={{ color: "#fff" }}
                                          >
                                            Healthy growth
                                          </a>
                                        </h5>
                                        <p className="qodef-m-text">
                                          essential for kids and moms-to-be
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p
                        style={{
                          width: "100%",
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "18px",
                          marginTop: "50px",
                        }}
                      >
                        An estimated 76% of Indians are Vitamin D deficient. Sun
                        Kissed Delight helps bridge that gap easily
                      </p>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default About;
